interface Booking {
  status: number;
  [key: string]: any;
}

type ActionItem = {
  label: string;
  onClick: () => void;
};

interface BookingActionOptions {
  booking: Booking;
  setRescheduleBooking: (booking: Booking) => void;
  setShowRescheduleModal: (val: boolean) => void;
  setCancelBooking: (booking: Booking) => void;
  setShowCancelPop: (val: boolean) => void;
}

export const getBookingActions = ({
  booking,
  setRescheduleBooking,
  setShowRescheduleModal,
  setCancelBooking,
  setShowCancelPop,
}: BookingActionOptions): ActionItem[] => {
  const actions: ActionItem[] = [];

  if (booking.status === 3) {
    actions.push({
      label: 'Reschedule',
      onClick: () => {
        setRescheduleBooking(booking);
        setShowRescheduleModal(true);
      },
    });
    actions.push({
      label: 'Cancel',
      onClick: () => {
        setCancelBooking(booking);
        setShowCancelPop(true);
      },
    });
  } else if (booking.status === 2) {
    actions.push({
      label: 'Cancel',
      onClick: () => {
        setCancelBooking(booking);
        setShowCancelPop(true);
      },
    });
  }

  return actions;
};
